export type Permissions =
  | 'admin'
  | 'editor'
  | 'partner'
  | 'notAuth'
  | 'CONTENT_CREATOR';

const AUTH_TOKEN_KEY = 'pikado_auth_token';
const AUTH_USER_KEY = 'pikado_user';

function parseJwtPayload(token: string | null): any | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(payload);
    return JSON.parse(decoded);
  } catch {
    return null;
  }
}

function getRoleCandidatesFromPayload(payload: any): string[] {
  if (!payload) return [];
  const candidates: string[] = [];
  if (Array.isArray(payload['cognito:groups'])) {
    candidates.push(...payload['cognito:groups']);
  }
  if (Array.isArray(payload.realm_access?.roles)) {
    candidates.push(...payload.realm_access.roles);
  }
  if (payload.resource_access && typeof payload.resource_access === 'object') {
    Object.values(payload.resource_access).forEach((resource: any) => {
      if (Array.isArray(resource?.roles)) {
        candidates.push(...resource.roles);
      }
    });
  }
  if (Array.isArray(payload.roles)) {
    candidates.push(...payload.roles);
  }
  if (payload.role) {
    candidates.push(payload.role);
  }
  return candidates.map((value: any) => String(value));
}

function getStoredUserRoles(): string[] {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    if (!raw) return [];
    const user = JSON.parse(raw);
    if (Array.isArray(user?.roles)) {
      return user.roles.map((role: any) => String(role));
    }
    if (user?.roles) {
      return [String(user.roles)];
    }
  } catch {
    return [];
  }
  return [];
}

export const getCurrentUserPermission = async (): Promise<Permissions> => {
  const userRoles = getStoredUserRoles();
  let groups = userRoles;

  if (groups.length === 0) {
    const payload = parseJwtPayload(localStorage.getItem(AUTH_TOKEN_KEY));
    groups = getRoleCandidatesFromPayload(payload);
  }

  const hasRole = (names: string[]) =>
    groups.some(group =>
      names.some(name => String(group).toLowerCase() === name.toLowerCase()),
    );

  if (hasRole(['Admins', 'admin'])) {
    return 'admin';
  }
  if (hasRole(['Editors', 'editor'])) {
    return 'editor';
  }
  if (hasRole(['Partners', 'partner'])) {
    return 'partner';
  }
  if (hasRole(['CONTENT_CREATOR', 'content_creator', 'content creator'])) {
    return 'CONTENT_CREATOR';
  }

  return 'notAuth';
};

export const handleRememberDevice = async () => {
  console.warn('Remember device is not supported for Keycloak login flow.');
};
